module.exports = __webpack_public_path__ + "img/gallery-icon-05.db65c4fe.png";